import { Injectable } from '@angular/core';
import { EmptyFunction, isNil, Nillable } from '@web/utils';
import { Confirmation } from '../models/confirmation';
import { RequiredMethodCallException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationBuilder {
  private _title: Nillable<string>;
  private _message: Nillable<string>;
  private _acceptLabel: Nillable<string>;
  private _rejectLabel: Nillable<string>;
  private _accept: Nillable<() => void>;
  private _reject: Nillable<() => void>;

  public constructor() {
    this.reset();
  }

  public reset(): this {
    this._title = null;
    this._message = null;
    this._acceptLabel = null;
    this._rejectLabel = null;
    this._accept = null;
    this._reject = null;

    return this;
  }

  public title(title: string): this {
    this._title = title;

    return this;
  }

  public message(message: string): this {
    this._message = message;

    return this;
  }

  public acceptLabel(acceptLabel: string): this {
    this._acceptLabel = acceptLabel;

    return this;
  }

  public rejectLabel(rejectLabel: string): this {
    this._rejectLabel = rejectLabel;

    return this;
  }

  public accept(accept: () => void): this {
    this._accept = accept;

    return this;
  }

  public reject(reject: () => void): this {
    this._reject = reject;

    return this;
  }

  public build(): Confirmation {
    this.requireTitle();
    this.requireMessage();
    this.requireAccept();
    this.configureDefaultAcceptLabel();
    this.configureDefaultRejectLabel();
    this.configureDefaultReject();

    const confirmation = new Confirmation(
      this._title!,
      this._message!,
      this._acceptLabel!,
      this._rejectLabel!,
      this._accept!,
      this._reject!,
    );

    this.reset();

    return confirmation;
  }

  private requireTitle(): void {
    if (isNil(this._title)) {
      throw new RequiredMethodCallException(this.title.name);
    }
  }

  private requireMessage(): void {
    if (isNil(this._message)) {
      throw new RequiredMethodCallException(this.message.name);
    }
  }

  private requireAccept(): void {
    if (isNil(this._accept)) {
      throw new RequiredMethodCallException(this.accept.name);
    }
  }

  private configureDefaultAcceptLabel(): void {
    if (isNil(this._acceptLabel)) {
      this.acceptLabel('Tak');
    }
  }

  private configureDefaultRejectLabel(): void {
    if (isNil(this._rejectLabel)) {
      this.rejectLabel('Nie');
    }
  }

  private configureDefaultReject(): void {
    if (isNil(this._reject)) {
      this.reject(EmptyFunction);
    }
  }
}
